import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-angle-right-icon',
  templateUrl: './navigation-angle-right.component.html'
})
export class NavigationAngleRightComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
